import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function EmailIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 17.92 14.19"
      style={{ width: `16px`, height: `16px`, color: RoutalPalette.primary40, ...props.style }}
    >
      <g>
        <path d="M16.37,14.08H1.55c-.79,0-1.43-.64-1.43-1.43V1.54c0-.36.14-.72.39-.98,0,0,.01-.02.02-.02C.81.27,1.17.11,1.55.11h14.83c.38,0,.74.15,1.01.42s.42.63.42,1.01v11.11c0,.79-.64,1.43-1.43,1.43ZM1.12,1.82v10.83c0,.23.19.43.43.43h14.82c.23,0,.43-.19.43-.43V1.82l-6.17,6.17c-.92.92-2.41.92-3.33,0L1.12,1.82ZM1.83,1.11l6.17,6.17c.25.26.59.4.96.4h0c.36,0,.7-.14.96-.4l6.17-6.17H1.83Z" />
      </g>
    </SvgIcon>
  );
}
